import { createContext, useContext } from 'react';

import { EUserType } from '../PageAuth/constants/authConstants';

export interface ISubscriberIdContext {
    subscriberId: string;
    userType: EUserType;
}

export const SubscriberIdContext = createContext<ISubscriberIdContext>({
    subscriberId: '',
    userType: EUserType.SACS_ID_READONLY,
});

export const useSubscriberIdContext = (): ISubscriberIdContext => {
    const context = useContext<ISubscriberIdContext>(SubscriberIdContext);
    if (!context) {
        throw new Error(
            'SubscriberId compound components cannot be rendered outside the SubscriberId component',
        );
    }

    return context;
};
